import { HEX_121820 } from '@tanium/colors';
import { defineColor } from '@tanium/react-theme-definition';

export const NotificationScrollerFill = defineColor(['transparent', HEX_121820]);
